import React from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import Message from 'antd/lib/message';

import Button from '@common/react/components/Forms/Button';

import { User } from '@app/objects/User';
import { request } from '@app/components/Api';

interface ComponentProps {
	user: User | null;
	locationId: number;
	locationName: string;
	children: any;
	className?: string;
}

interface SupportChatResult {
	locationId: number;
	locationName: string;
	id: number;
}

export const SupportButton: React.FC<ComponentProps> = ({
	user,
	locationId,
	locationName,
	children,
	className,
}) => {
	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const history = useHistory();

	const createLocationChat = () => {
		if (user) {
			if (locationId > 0) {
				setIsLoading(true);

				request<SupportChatResult>('supportChat', {
					locationId,
					locationName,
				}).then((res) => {
					history.replace({
						pathname: '/chats',
						search: `?chatId=${res.id}`,
					});
				}).catch(() => {
					setIsLoading(false);
					history.push('/contact-support');
				}).finally(() => {
					setIsLoading(false);
				});
			} else {
				Message.error('Invalid locationId');
			}
		}
	};

	return <>
		<Button
			type="button"
			className={className || 'btn btn-primary'}
			title="Open support chat"
			onClick={createLocationChat}
			isLoading={isLoading}
		>
			{children}
		</Button>
	</>;
};
